define([
    "dojo/_base/declare",
    "csi/def/Action"
], function(declare,Action) {

    return declare(Action,  {

        validate: function(/*Context*/ctx) {
            //summary: TA23596:"Generate Data Package PDFs" should be available only on Style and Material select sets
            var bResult = true;
            var node = ctx.getNode();
            if(node.$Type == "SelectSet") {
                bResult = node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style" || node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Material";
            }
            return bResult && this.inherited(arguments);
        }
    });
});